module.exports = __webpack_public_path__ + "static/img/banner7.c4c8855.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner7.png
// module id = 8Cfj
// module chunks = 52